import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedHelpSupportOnlineConsultation,
  updateAtmedHelpSupportOnlineConsultation
} from '../../../store/actions';
import HelpSupport from './help';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results,
  updateResult: vendorEquipmenReducer.updateResult,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedHelpSupportOnlineConsultation,
    updateAtmedHelpSupportOnlineConsultation
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(HelpSupport);
